<template>
  <div class="party-wrap">
    <!-- 大党委标题 -->
    <header class="party-header">
      <img
        class="party-header_img"
        src="@/assets/images/partyDetail/flag.png"
        :title="party.zoneName"
      />
      <div class="party-header_title">{{ party.zoneName }}</div>
    </header>

    <!-- 定位信息 -->
    <section class="brief">
      <div class="brief-address" v-if="party.address">
        <i class="iconfont icon-dingweiweizhi"></i>
        <span class="location-info_text">{{ party.address }}</span>
      </div>
      <!-- 简介内容 -->
      <div class="brief-text">{{ party.remark }}</div>
      <!-- 图片 -->
      <div class="brief-img-list">
        <img
          class="brief-img_item"
          v-for="item in party.picList"
          :key="item.id"
          :src="item.picPath"
        />
      </div>
      <Button
        class="party-btn location-info_btn"
        type="warning"
        @click="locationModal.value = true"
        >编辑</Button
      >
    </section>

     <!-- 第一书记 -->
    <section class="shuji-wrap">
      <div class="user-header">{{ shuji1.name }}</div>
      <!-- 书记列表 -->
      <div class="shuji-list" v-if="shuji1.value.length">
        <bk-person
          class="shuji-list_item"
          v-for="item in shuji1.value"
          :imgSize="160"
          :key="item.id"
          :user="item"
          @on-edit="onPersonEdit(item)"
          @on-delete="onPersonDelete(item)"
        ></bk-person>
      </div>
      <!-- 没有书记时显示添加 -->
      <img
        v-if="!shuji.value.length"
        class="no-person_img"
        src="@/assets/images/partyDetail/no-person.png"
        title="暂无数据"
      />
      <Button
        v-if="!shuji1.value.length"
        class="party-btn"
        type="warning"
        @click="onSJ1Add"
        >添加</Button
      >
    </section>

    <!-- 社区书记 -->
    <section class="shuji-wrap">
      <div class="user-header">{{ shuji.name }}</div>
      <!-- 书记列表 -->
      <div class="shuji-list" v-if="shuji.value.length">
        <bk-person
          class="shuji-list_item"
          v-for="item in shuji.value"
          :imgSize="160"
          :key="item.id"
          :user="item"
          @on-edit="onPersonEdit(item)"
          @on-delete="onPersonDelete(item)"
        ></bk-person>
      </div>
      <!-- 没有书记时显示添加 -->
      <img
        v-if="!shuji.value.length"
        class="no-person_img"
        src="@/assets/images/partyDetail/no-person.png"
        title="暂无数据"
      />
      <Button
        v-if="!shuji.value.length"
        class="party-btn"
        type="warning"
        @click="onSJAdd"
        >添加</Button
      >
    </section>

    <!-- 专职委员 -->
    <section class="zhuanzhi-wrap">
      <div class="user-header">{{ zhuanzhi.name }}</div>
      <!-- 专职委员列表 -->
      <div class="zhuanzhi-list">
        <bk-person
          class="zhuanzhi-list_item"
          :imgSize="160"
          v-for="item in zhuanzhi.value"
          :key="item.id"
          :user="item"
          @on-edit="onZhuanzhiEdit(item)"
          @on-delete="onPersonDelete(item)"
        ></bk-person>
      </div>
      <!-- 没有专职委员时显示添加 -->
      <img
        v-if="!zhuanzhi.value.length"
        class="no-person_img"
        src="@/assets/images/partyDetail/no-person.png"
        title="暂无数据"
      />
      <Button class="party-btn" type="warning" @click="onZZAdd">添加</Button>
    </section>
    <!-- 兼职委员 -->
    <section class="jianzhi-wrap">
      <div class="user-header">{{ jianzhi.name }}</div>
      <div class="jianzhi-list">
        <bk-person
          class="jianzhi-list_item"
          :imgSize="160"
          v-for="item in jianzhi.value"
          :key="item.id"
          :user="item"
          @on-edit="onJianzhiEdit(item)"
          @on-delete="onPersonDelete(item)"
        ></bk-person>
      </div>
      <img
        v-if="!jianzhi.value.length"
        class="no-person_img"
        src="@/assets/images/partyDetail/no-person.png"
        title="暂无数据"
      />
      <Button class="party-btn" type="warning" @click="onJZAdd">添加</Button>
    </section>

    <!-------------- 弹窗 -------------->
    <!-- 位置编辑 弹窗 -->
    <form-modal
      :modal="locationModal"
      :form-option="locationOption"
      @on-ok="onLocationConfirm"
    ></form-modal>
    <!-- 添加书记的modal -->
    <form-modal
      :modal="sj_Modal"
      :form-option="sj_option"
      @on-ok="onSJConfirm"
      @autocomplete-on-select="onSJSelect"
    ></form-modal>
    <form-modal
      :modal="sj1_Modal"
      :form-option="sj1_option"
      @on-ok="onSJConfirm"
      @autocomplete-on-select="onSJ1Select"
    ></form-modal>
    <!-- 专职委员的modal -->
    <form-modal
      :modal="zz_Modal"
      :form-option="zz_option"
      @on-ok="onSJConfirm"
      @autocomplete-on-select="onZZSelect"
    ></form-modal>
    <!-- 兼职委员的modal -->
    <form-modal
      :modal="jz_Modal"
      :form-option="jz_option"
      @on-ok="onSJConfirm"
      @autocomplete-on-select="onJZSelect"
    ></form-modal>
  </div>
</template>

<script>
import formModal from "@/components/form-modal";
import bkPerson from "./components/person";

/* 设置简介表单 */
function setBriefOption({
  brief = {
    value: ""
  },
  map = {
    value: "",
    longitude: "",
    latitude: ""
  },
  uploadImg = {
    imgArr: []
  }
}) {
  let _brief = {
    type: "input",
    name: "brief",
    inputType: "textarea",
    title: "简介",
    value: brief.value
  };
  let _map = {
    type: "map",
    name: "map",
    title: "位置",
    value: map.value,
    longitude: map.longitude,
    latitude: map.latitude
  };

  let _picture = {
    type: "upload-img",
    name: "picture",
    title: "",
    imgNumber: 3,
    imgArr: uploadImg.imgArr
  };
  // 默认四个
  let res = [_map, _brief, _picture];

  return res;
}

// 书记的配置
function getSJOption({
  context,
  type,
  autoComplete = {
    value: "",
    disabled: false
  },
  avatar = {
    src: ""
  },
  phone = {
    value: ""
  },
  originData = []
}) {
  return [
    {
      type: "auto-complete",
      title: "姓名",
      name: "name",
      value: autoComplete.value,
      disabled: autoComplete.disabled,
      url: context.urlobj.partyList4add,
      originData: originData,
      params: {
        zoneId: context.partyId,
        typeId: type.id,
        userName: "",
        valueRelated: "userName" // 将value赋值到该字段指向的属性
      }
    },
    {
      type: "avatar",
      name: "avatar",
      title: "头像",
      src: avatar.src
    },
    {
      type: "input",
      name: "phone",
      title: "工作电话",
      inputType: "tel",
      value: phone.value
    }
  ];
}
// 书记的配置
function getSJ1Option({
  context,
  type,
  autoComplete = {
    value: "",
    disabled: false
  },
  avatar = {
    src: ""
  },
  phone = {
    value: ""
  },
  originData = []
}) {
  return [
    {
      type: "auto-complete",
      title: "姓名",
      name: "name",
      value: autoComplete.value,
      disabled: autoComplete.disabled,
      url: context.urlobj.partyList4add,
      originData: originData,
      params: {
        zoneId: context.partyId,
        typeId: type.id,
        userName: "",
        valueRelated: "userName" // 将value赋值到该字段指向的属性
      }
    },
    {
      type: "avatar",
      name: "avatar",
      title: "头像",
      src: avatar.src
    },
    {
      type: "input",
      name: "phone",
      title: "工作电话",
      inputType: "tel",
      value: phone.value
    }
  ];
}
// 专职委员 和 兼职委员
function getZZOption({
  context,
  type,
  autoComplete = {
    value: "",
    disabled: false
  },
  avatar = {
    src: ""
  },
  phone = {
    value: ""
  },
  job = {
    value: ""
  },
  order = {
    value: "",
    max:Infinity
  },
  originData = []
}) {
  return [
    {
      type: "auto-complete",
      title: "姓名",
      name: "name",
      value: autoComplete.value,
      disabled: autoComplete.disabled,
      url: context.urlobj.partyList4add,
      originData: originData,
      params: {
        zoneId: context.partyId,
        typeId: type.id,
        userName: "",
        valueRelated: "userName" // 将value赋值到该字段指向的属性
      }
    },
    {
      type: "avatar",
      name: "avatar",
      title: "头像",
      src: avatar.src
    },
    {
      type: "input",
      name: "job",
      title: "职务",
      value: job.value
    },
    {
      type: "input",
      name: "phone",
      title: "工作电话",
      inputType: "tel",
      value: phone.value
    },
    {
      type: "input-number",
      name: "order",
      title: "排序",
      value: order.value,
      min:1,
      max:order.max
    }
  ];
}
function getJZOption({
  context,
  type,
  autoComplete = {
    value: "",
    disabled: false
  },
  avatar = {
    src: ""
  },
  phone = {
    value: ""
  },
  job = {
    value: ""
  },
  originData = []
}) {
  return [
    {
      type: "auto-complete",
      title: "姓名",
      name: "name",
      value: autoComplete.value,
      disabled: autoComplete.disabled,
      url: context.urlobj.partyList4add,
      originData: originData,
      params: {
        zoneId: context.partyId,
        typeId: type.id,
        userName: "",
        valueRelated: "userName" // 将value赋值到该字段指向的属性
      }
    },
    {
      type: "avatar",
      name: "avatar",
      title: "头像",
      src: avatar.src
    },
    {
      type: "input",
      name: "job",
      title: "职务",
      value: job.value
    },
    {
      type: "input",
      name: "phone",
      title: "工作电话",
      inputType: "tel",
      value: phone.value
    }
  ];
}
export default {
  name: "ddw",
  components: { formModal, bkPerson },
  props: {},
  data() {
    return {
      party: {},
      shuji: {
        name: "",
        value: []
      },
      shuji1: {
        name: "",
        value: []
      },
      zhuanzhi: {
        name: "",
        value: []
      },
      jianzhi: {
        name: "",
        value: []
      },
      editPerson: null, // 当前编辑的人员
      // 显示编辑简介弹窗
      locationModal: {
        value: false,
        title: "编辑"
      },
      locationOption: [],
      // 书记编辑
      sj_Modal: {
        value: false,
        title: "添加"
      },
      sj_option: [],
      // 第一书记
      sj1_Modal: {
        value: false,
        title: "添加"
      },
      sj1_option: [],
      // 专职委员
      zz_Modal: {
        value: false,
        title: "添加"
      },
      zz_option: [],
      // 兼职委员
      jz_Modal: {
        value: false,
        title: "添加"
      },
      jz_option: [],
      // 书记 第一书记 专职委员 兼职委员 字典表
      dic_shuji: null,
      dic_fisrtShuji: null,
      dic_zhuanzhi: null,
      dic_jianzhi: null
    };
  },
  watch: {},
  computed: {},
  methods: {
    /* 获取大党委详情 */
    getDetail() {
      let url = this.urlobj.getPartyDetail(this.partyId);
      this.$showLoading();
      this.$get(url)
        .then(res => {
          if (!res.isSucceed) return this.$Message.error(res.message);
          this.party = res.rows[0];
          let _point = [this.shuji1, this.shuji, this.zhuanzhi, this.jianzhi];

          Object.keys(this.party.userMapList).forEach((item, index) => {
            if (!_point[index]) return;
            _point[index].name = item;
            _point[index].value = this.party.userMapList[item];
          });
          // 更新地图坐标点
          let _location = JSON.parse(this.party.coordinate);
          this.locationOption = setBriefOption({
            map: {
              value: this.party.address,
              longitude: _location && _location.x,
              latitude: _location && _location.y
            },
            brief: {
              value: this.party.remark
            },
            uploadImg: {
              imgArr: this.party.picList.map(item => {
                return {
                  id: item.id,
                  picId: item.picId,
                  path: item.picPath
                };
              })
            }
          });


          //edit by wangxuefei
          //增加专职委员顺序
          this.zhuanzhi.value.forEach((item,index)=>{
            item.order = index+1
          })
        })
        .finally(this.$hideLoading);
    },
    /* 初始化动态参数的modal */
    initDic() {
      // 查询参数对应的字典表
      let url = this.urlobj.dictionaryList("comm_party_user_category");
      this.$get(url).then(res => {
        if (!res.isSucceed) return this.$Message.error(res.message);

        for (let item of res.rows) {
          if (item.dicType === "comm_party_user_category_1")
            this.dic_shuji = item;
          if (item.dicType === "comm_party_user_category_2")
            this.dic_zhuanzhi = item;
          if (item.dicType === "comm_party_user_category_3")
            this.dic_jianzhi = item;
          if (item.dicType === "comm_party_user_category_4")
            this.dic_fisrtShuji = item;
        }
      });
    },
    /* 书记打开弹窗 初始化表单 */
    onSJAdd() {
      this.sj_Modal = {
        value: true,
        title: "添加"
      };
      // 初始化 书记编辑的 modal
      this.sj_option = getSJOption({
        context: this,
        type: this.dic_shuji
      });
    },
    onSJ1Add() {
      this.sj1_Modal = {
        value: true,
        title: "添加"
      };
      // 初始化 书记编辑的 modal
      this.sj1_option = getSJ1Option({
        context: this,
        type: this.dic_fisrtShuji
      });
    },
    // 
    /* 专职打开弹窗 初始化表单 */
    onZZAdd() {
      this.zz_Modal = {
        value: true,
        title: "添加"
      };
      // 初始化 专职委员的 modal
      this.zz_option = getZZOption({
        context: this,
        type: this.dic_zhuanzhi
      });
      this.zz_option[4].max = this.zhuanzhi.value.length+1
      this.zz_option[4].value = this.zhuanzhi.value.length+1
    },
    /* 兼职打开弹窗 初始化表单 */
    onJZAdd() {
      this.jz_Modal = {
        value: true,
        title: "添加"
      };
      // 初始化兼职委员
      this.jz_option = getJZOption({
        context: this,
        type: this.dic_jianzhi
      });
    },
    /* 定位编辑完毕 */
    onLocationConfirm(formOption) {
      let _map = formOption.get("map"),
        _brief = formOption.get("brief"),
        _picture = formOption.get("picture");

      if (_map.value === "") return this.$Message.info("地点尚未填写");
      if (_map.latitude === "") return this.$Message.info("地点需从地图选取");

      let url = this.urlobj.party;
      let data = {
        id: this.partyId,
        zoneType: this.zoneType,
        communityId: this.orgId,
        remark: _brief.value,
        picList: _picture.imgArr,
        address: _map.value,
        coordinate: JSON.stringify({ x: _map.longitude, y: _map.latitude })
      };
      this.$post(url, data).then(res => {
        if (!res.isSucceed) return this.$Message.error(res.message);
        this.getDetail();
      });
    },
    /* 书记 添加 */
    onSJConfirm(formOption) { 
      let user = formOption.get("name"),
        userOrigin = user.originData[0], // 取用户校验用的值
        userValue = user.value, // 取用户校验用的值
        avatar = formOption.get("avatar"),
        phone = formOption.get("phone"),
        job = formOption.get("job"); // 可能不存在

      let order = formOption.get("order")?formOption.get("order"):null;
     
      // 编辑模式下更换用户数据来源 以及 跳过校验
      if (user.disabled) {
        userOrigin = this.editPerson;
      }
      if (!user.disabled) {
        // 选取的用户姓名不能编辑 校验
        // if (!userOrigin) return this.$Message.warning("用户姓名不存在");

        // if (user.value !== userOrigin.userName)
        //   return this.$Message.warning("用户不在选择列表");
      }
      let url = this.urlobj.partyUser,
        data = {
          zoneId: this.partyId,
          typeId: user.params.typeId,
          // unionId: userOrigin.unionId,
          // userName: userOrigin.userName,
          userName: userValue,
          headPicUrl: avatar.src,
          phoneNO: phone.value,
          proTitle: job ? job.value : this.orgName + "党支部书记"
        };
      // 修改人员 添加参数
      if (user.disabled) {
        data.id = userOrigin.id;
      }
      if(userOrigin) {
        data.unionId =  userOrigin.unionId,
        data.userName = userOrigin.userName
      }
      this.$showLoading();
      this.$post(url, data)
        .then(res => {
          if (!res.isSucceed) return this.$Message.error(res.message);
          if(order){
            let ordervalue = order.value?parseInt(order.value):this.zhuanzhi.value.length
            //edit by wxf 增加排序
            this.submitOrder(ordervalue , data.id || res.newPrimaryKeys.id,user.params.typeId)

          }else{
              this.$Message.success("添加成功");
              this.getDetail();

              // 更新list 页面视图
              this.$bus.$emit("miniParty_personChange");
          }
         
        })
        .finally(this.$hideLoading);
    },
    submitOrder(order,id,typeId){
        //处理排序逻辑
        let newPeopleArr = this.zhuanzhi.value.map(item=>item.id)
        let selectindex = -1
        newPeopleArr.forEach((item,index)=>{
          if(item == id) selectindex = index
        })
        debugger
        console.log(newPeopleArr)
        //如果原来有这个人，则先删掉这个人
        if(selectindex>-1) newPeopleArr.splice(selectindex, 1)
        console.log(newPeopleArr)
        //把选中的人插入到他应该在的位置
        newPeopleArr.splice(order-1,0,id)
        console.log(newPeopleArr)
        
        let sortData = newPeopleArr.map((item,index)=>{
          return{
            id:item,
            sort:++index,
            typeId
          }
        })
        
        this.$post(this.urlobj.partyUserOrder,sortData).then(res=>{
            this.$hideLoading
            this.$Message.success("添加成功");
            this.getDetail();

            // 更新list 页面视图
            this.$bus.$emit("miniParty_personChange");
        }).finally(this.$hideLoading);
    },
    /* 书记搜索填充 */
    onSJSelect(selected, disabled = false) {
      // 重置组件
      this.sj_option = getSJOption({
        context: this,
        type: this.dic_shuji,
        autoComplete: {
          value: selected.userName,
          disabled: disabled
        },
        avatar: {
          src: selected.headPicUrl
        },
        phone: {
          value: selected.phoneNO
        },
        originData: [selected]
      });
    },
    /* 第一书记搜索填充 */
    onSJ1Select(selected, disabled = false) {
      // 重置组件
      this.sj1_option = getSJ1Option({
        context: this,
        type: this.dic_fisrtShuji,
        autoComplete: {
          value: selected.userName,
          disabled: disabled
        },
        avatar: {
          src: selected.headPicUrl
        },
        phone: {
          value: selected.phoneNO
        },
        originData: [selected]
      });
    },
    /* 专职搜索填充 */
    onZZSelect(selected, disabled = false) {
      let max = this.zhuanzhi.value.length
      this.zz_option = getZZOption({
        context: this,
        type: this.dic_zhuanzhi,
        autoComplete: {
          value: selected.userName,
          disabled: disabled
        },
        avatar: {
          src: selected.headPicUrl
        },
        job: {
          value: selected.proTitle
        },
        phone: {
          value: selected.phoneNO
        },
        order: {
          value: selected.order,
          max:max
        },
        originData: [selected]
      });
      console.log(this.zz_option)  

    },
    /* 兼职搜索填充 */
    onJZSelect(selected, disabled = false) {
      this.jz_option = getJZOption({
        context: this,
        type: this.dic_jianzhi,
        autoComplete: {
          value: selected.userName,
          disabled: disabled
        },
        avatar: {
          src: selected.headPicUrl
        },
        job: {
          value: selected.proTitle
        },
        phone: {
          value: selected.phoneNO
        },
        originData: [selected]
      });
    },
    /* 人员删除弹窗 */
    onPersonDelete(person) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>确认要进行删除操作吗？</p>",
        onOk: () => {
          // 执行删除操作
          let url = this.urlobj.partyUserDelete(person.id);
          this.$delete(url).then(res => {
            if (!res.isSucceed) return this.$Message.error(res.message);
            this.$Message.success("删除成功");
            this.getDetail(); // 刷新页面

            // 更新list 页面视图
            this.$bus.$emit("miniParty_personChange");
          });
        }
      });
    },
    /* 人员编辑 */
    onPersonEdit(person) {
      // 打开弹窗
      this.sj_Modal = {
        value: true,
        title: "编辑"
      };
      // 回填信息
      this.onSJSelect(person, true);
      // 赋值初始人员
      this.editPerson = person;
    },
    onZhuanzhiEdit(person) {
      // 打开弹窗
      this.zz_Modal = {
        value: true,
        title: "编辑"
      };
      // 回填信息
      this.onZZSelect(person, true);
      // 赋值初始人员
      this.editPerson = person;
    },
    onJianzhiEdit(person) {
      // 打开弹窗
      this.jz_Modal = {
        value: true,
        title: "编辑"
      };
      // 回填信息
      this.onJZSelect(person, true);
      // 赋值初始人员
      this.editPerson = person;
    }
  },
  created() {},
  mounted() {
    this.partyId = this.$route.query.id; // 支部id
    this.orgId = this.$route.query.orgId; // 社区id
    this.orgName = this.$route.query.orgName; // 社区名称
    this.zoneType = this.$route.query.zoneType; // 支部类型
    this.getDetail();
    // 初始化字典表
    this.initDic();
  }
};
</script>
<style lang="less" scoped>
@marginGap: 0.2rem;
@adderessFontSize: 0.24rem;

.party-wrap {
  .flex(center, @flexDirection:column);
}
/* 头部 */
.party-header {
  .flex(center);
  margin: @marginGap 0;
}
.party-header_img {
  height: 0.7rem;
  width: 0.7rem;
  margin-bottom: -@marginGap;
}
.party-header_title {
  font-family: "KaiTi";
  font-size: 0.48rem;
  font-weight: 600;
  color: transparent;
  background: url("~@/assets/images/partyDetail/orgTitleBg.jpg");
  background-repeat: repeat-x;
  background-clip: text;
  -webkit-background-clip: text;
  max-width: 20em;
}
/* 定位 */
.brief {
  .flex(center, @flexDirection:column);
  max-width: 10rem;
}
.brief-address {
  font-size: 0.24rem;
  color: #666;
  .icon-dingweiweizhi {
    font-size: inherit;
    color: #ff7b44;
  }
}
.brief-text {
  width: 100%;
  color: #333;
  text-align: left;
  font-size: 0.26rem;
  line-height: 2em;
  text-indent: 2em;
}
.brief-img-list {
  .flex(center, @flexWrap:wrap);
  width: 100%;
  margin: 20px 0;
}
.brief-img_item {
  width: 3rem;
  height: auto;
  margin: 0 10px 10px 0;
}
/* 社区书记 */
.shuji-wrap,
.zhuanzhi-wrap,
.jianzhi-wrap {
  .flex(center, @flexDirection:column);
  margin-top: 0.6rem;
}
.shuji-list,
.zhuanzhi-list,
.jianzhi-list {
  .flex(center, center, @flexWrap:wrap);
  margin-top: 40px;
  &_item {
    margin: 0 0.4rem;
  }
}
.user-header {
  position: relative;
  font-size: 0.36rem;
  color: #4b4b4b;
  font-weight: bolder;
  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: calc(-0.6rem - 0.2rem);
    background: url("~@/assets/images/partyDetail/org-admin-icon.png");
    background-size: 100%;
    height: 0.32rem;
    width: 0.6rem;
    transform: translateY(-50%);
  }
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    right: calc(-0.6rem - 0.2rem);
    background: url("~@/assets/images/partyDetail/org-admin-icon.png");
    background-size: 100%;
    height: 0.32rem;
    width: 0.6rem;
    transform: rotateY(180deg) translateY(-50%);
  }
}
.party-btn {
  padding: 8px 0.3rem;
  font-size: 0.26rem;
  line-height: 1;
  margin-top: @marginGap;
}
.no-person_img {
  width: 3rem;
  height: auto;
}
</style>
